
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { AddCompletedDigitalFormReqVM, DeleteFormVM, DigitalFormQuestionComment, DigitalFormQuestionImages, DigitalFormQuestionsCategoriesVM, DigitalFormQuestionsVM, EditQuestionImages, FormGroupedByCategoryVM, IdNameVM, SiteCodes, UpdateHistoryVM, UsersVM } from '../entities/global/model';
import { ModelAnswerList } from '../favourite-dialog/favourite-dialog-modal';
import { FormsVM } from '../perform-induction/perform-induction';
import { SafetyConfigService } from '../services/safety-config.service';
import { SafetyFormsService } from '../services/safety-forms.service';
import { SafetyGeneraldashboardService } from '../services/safety-generaldashboard.service';
import { SafetyInductionService } from '../services/safety-induction.service';
import { DigitalEditCommentDialogComponent } from './digital-edit-comment-dialog/digital-edit-comment-dialog.component';
import { EditImageDialogEditformsComponent } from './edit-image-dialog-editforms/edit-image-dialog-editforms.component';
import moment from 'moment'; 
import { DatePipe } from '@angular/common';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { AppService } from '../../../app.service';
import { NotificationsService } from 'angular2-notifications';
import { ConfirmationMessageDeleteormsComponent } from '../upload-form-edit/confirmation-message-deleteorms/confirmation-message-deleteorms.component';
import { FileReaderEvent } from '../setup-implement/setup-implement.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';



@Component({
  selector: 'app-edit-digital-forms',
  templateUrl: './edit-digital-forms.component.html',
  styleUrls: ['./edit-digital-forms.component.css'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})
export class EditDigitalFormsComponent implements OnInit {
  today = new Date();
  constructor(private _safetyGeneraldashboardService: SafetyGeneraldashboardService,
    private SafetyFormsService_: SafetyFormsService,
    private _sanitizer: DomSanitizer, private _inductionService: SafetyInductionService,
    public dialog: MatDialog, private route: ActivatedRoute, private _safetyConfigService:SafetyConfigService,
    private _appService: AppService,

    private _router:Router,
    private _notify: NotificationsService,) { 
      this.today.setDate(this.today.getDate());
    }

  users: UsersVM[] = []
  Image
  UploadImages_: string[] = null
  ImageList: string[] = []
  selectedFile: FileList;
  dateCompleted=null

  groupedForms: FormGroupedByCategoryVM[]
  Froms: IdNameVM[]
  Name
  FormCategoryId: number = 0
  RequireIncidentNo:boolean
  DataForFormSetup: FormsVM;
  incidentTypes: IdNameVM[]
  QuestionCategories: DigitalFormQuestionsCategoriesVM[]
  questionsAns: DigitalFormQuestionsVM[]
  QComments: DigitalFormQuestionComment[]
  isActiveFollowUpRequired=false
  isActiveFollowUpCompleted=false
  fololowupUser=null
  FollowUpDate=null
  relatedUser=null
  Notes="";
  NewFileName: string = "";
  FilePreview: string = "";
  downloadFileName:string;
  Id: number
  UploadId:number
  reportIncidentID = ""
  incidentType=0
  EditedQuestionImage_
  ModelAnswers_: ModelAnswerList[]
  AddedByUser
  ModifiedByUser
  DateAdded
  DateModified
  inputForm
  siteCodesList: SiteCodes[]=[];
  inputValuestate
  FormId=0
  UpdateHistory:UpdateHistoryVM
  //radio button
  ModelAnswers: any = [];//options
  answers: any = [];//option
  QuestionComment:string
  FileList: string[] = [];
  UploadedFiles: string[] = [];
  UploadedImages: string[] = [];
  fileHeader = new Map();
  savingForm: boolean;
  ngOnInit() {
    this.base64FileHeaderMapper();
    this._appService.setPageTitle('Edit Digital Forms');
    this.route.params.subscribe(params => {
      this.Id = +params['Id'];

      if (this.Id) {
        this.upload();
      }
  });
  this.GetUsers();
  //this.upload();
  this._GETSetupForms();
  this.loadSiteList();
  this.GetIncidentTypesForDropDownLists();
  }
  
  state = new FormControl("", [Validators.required]);
  getErrorMessage() {
    return this.state.hasError("required") ? "You must enter a value" : "";
  }
  
  loadSiteList()
  {
   this._safetyConfigService.getAllSitesList().subscribe(sites =>
   { 
    // console.log('sitelist',sites)
     this.siteCodesList=sites;
     
   });
  }
  sanitize(image: string) {
    // console.log("img11111111111111",Image)
    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }
  //question add images
  sanitize_(image: string) { 
    return this._sanitizer.bypassSecurityTrustUrl(`${image}`);
  }


  //Form Image
  //uploadPhotoToForm(newPhoto: string) {
  //  this.Image = newPhoto.split(",")[1];
  //  let Imgarray = [];
  //  Imgarray.push(this.Image);
  //  if (this.ImageList != null) {
  //    this.ImageList.push(this.Image)
  //  }
  //  else
  //    this.ImageList = Imgarray
  //  //console.log(this.ImageList)
  //}


  onSelectPhotoAddImagetoForm(event: any) {
    //if (event.target.files && event.target.files[0]) {
    //  var reader = new FileReader();
    //  this.selectedFile = event.target.files[0];
    //  reader.onloadend = (e) => {
    //    this.uploadPhotoToForm(reader.result as string);
    //  }
    //  reader.readAsDataURL(event.target.files[0]);
    //}
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (this.UploadedImages.indexOf(event.target.files[i]["name"]) < 0) {
          this.UploadedImages.push(event.target.files[i]["name"]);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.ImageList.push(event.target.result.split(",")[1])
          };
          reader.readAsDataURL(event.target.files[i]);
        }
      }
    }
  }

  //Question Image
 
  uploadedImages_Q =[];//qid,images
  //uploadedImages_Q2 : DigitalFormQuestionImages[] =[]
  questionImageArray= []
  uploadPhoto(newPhoto: string, ques: DigitalFormQuestionsVM) {//QuestionImage :string
   
    var existingArr = this.uploadedImages_Q.find(f => f.qId == ques.QuestionId)//nadee
    this.Image = newPhoto.split(",")[1];
    let arraimg =[];
    if (existingArr != null) {
      arraimg = ques.UploadImages;
      arraimg.push(this.Image);
      ques.UploadImages=arraimg;
      existingArr.images.push(this.Image)
      

      // this.uploadedImages_Q.map(x=>{
      //   if(x.qId == ques.QuestionId){
      //     x.images =ques.UploadImages;
      //   }
      // })
    //  this.uploadedImages_Q2 =this.questionImageArray.push(this.uploadedImages_Q)//nadee
console.log("upload images not null",this.uploadedImages_Q)
    }

    else {
      let array_ =[];
      var obj_ = {
        qId: ques.QuestionId,
        images: []
      }
     

      obj_.images.push(this.Image);
      array_.push(obj_);
  
   

   this.uploadedImages_Q.push(obj_);
  
    
       arraimg.push(this.Image)
       ques.UploadImages = arraimg;
    //   array_.push(obj_);
    //   this.uploadedImages_Q=array_;
    
    
  }
  }

  onSelectPhoto(event: any, ques: DigitalFormQuestionsVM) {
    // if (event.target.files && event.target.files[0]) {
    //   var reader = new FileReader();
    //   this.selectedFile = event.target.files[0];
    //   reader.onloadend = (e) => {
    //     this.uploadPhoto(reader.result as string, ques);

    //   }
    //   reader.readAsDataURL(event.target.files[0]);
    // }
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (this.UploadedImages.indexOf(event.target.files[i]["name"]) < 0) {
          this.UploadedImages.push(event.target.files[i]["name"]);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.uploadPhoto(reader.result as string, ques);
          };
          reader.readAsDataURL(event.target.files[i]);
        }
      }
    }
  }

  //delete photo
  delete(i, ques: DigitalFormQuestionsVM) {
    ques.UploadImages.pop()
  }

  GetUsers() {
    this._safetyGeneraldashboardService.GetUsersForSafetyApp().subscribe(res => {
      this.users = res
     
      res.map(x => {
        //  this.UserName=x.UserName
      }
      )
    })
  }
  GetIncidentTypesForDropDownLists() {
    this.SafetyFormsService_.GetIncidentTypesForDropDownLists().subscribe(res => {
      this.incidentTypes = res;
      
    })
  }


  GetAdminLinkToAddUsers() {
    this._router.navigate(['/administrator']);
   // this.SafetyFormsService_.GetAdminLinkToAddUsers().subscribe(res => {
     // console.log(res)
      //this.document.location.href = res;
    //  window.open(res);
    //})
  }



  upload() {
    //this.savingForm = true;
    this._inductionService.GETFormUploadDataEdit(this.Id).subscribe(resupload => {

      this.groupedForms = resupload.Forms
      this.groupedForms.map(x => {
        this.Froms = x.Froms
      })
      console.log('upload edit res', resupload)
     // console.log('upload groupled forms', this.groupedForms)
   
      this.QuestionCategories = resupload.FormCategories
      
      this.questionsAns = resupload.Questions
     this.QComments=resupload.QuestionComments
     console.log("this.QComments", this.QComments)
//this.QuestionComment=resuplo
      //map data

      this.FormCategoryId = this.groupedForms[0].FormCategoryId
     this.RequireIncidentNo=this.groupedForms[0].RequireIncidentNo


     this.dateCompleted= resupload.FormUploadData.DateCompleted
     this.Notes=resupload.FormUploadData.Notes
     this.isActiveFollowUpRequired=resupload.FormUploadData.FollowUpRequired
     this.isActiveFollowUpCompleted=resupload.FormUploadData.FollowUpCompleted
      this.FollowUpDate=resupload.FormUploadData.FollowUpDate
     //.users=resupload.FormUploadData.CreatedUser
     this.AddedByUser=resupload.UpdateHistory.AddedByUser
     this.ModifiedByUser=resupload.UpdateHistory.ModifiedByUser
     this.DateAdded=resupload.UpdateHistory.DateAdded
     this.DateModified=resupload.UpdateHistory.DateModified
    this.inputForm= resupload.FormUploadData.Form
    this.relatedUser=resupload.FormUploadData.RelatedUser
    this.fololowupUser=resupload.FormUploadData.FollowUpUser
    this.reportIncidentID=resupload.FormUploadData.IncidentId
    this.incidentType=resupload.FormUploadData.IncidentType
    this.ImageList=resupload.FormUploadData.Images
    this.FormId=resupload.FormUploadData.Form
    this.UpdateHistory=resupload.UpdateHistory
    this.inputValuestate=resupload.FormUploadData.SiteId;
    this.downloadFileName=resupload.FormUploadData.File;
    this.FilePreview=resupload.FormUploadData.File;
    this.NewFileName=resupload.FormUploadData.FileName;
    this.FileList = resupload.FormUploadData.FormFiles;
    // console.log("this.questionsAns ",this.questionsAns )
     // this.savingForm = false;
    })
  }
  

  _GETSetupForms() {
    //this.savingForm = true;
    this._inductionService.GETSetupForms().subscribe(res => {
      
      if (res.m_Item1) {

        let arr = res.m_Item2
        arr.Categories.map(c => {
          let _forms = arr.Forms.filter(f => f.FormCategoryID == c.ID)
          c.Forms = _forms
        })
        this.DataForFormSetup = arr

        
      }
      //this.savingForm = true;
    })
  }


  EditQuestionImages_2=[]
  openEditImageDialogEditforms(QuestionImage, QuestionId, Question: DigitalFormQuestionsVM) {
    const dialogRef = this.dialog.open(EditImageDialogEditformsComponent, {
      data: {
        photoWithExt: 'data:image/*;base64,' + QuestionImage,
        QuestionId: QuestionId
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res != null) {
         Question.EditedQuestionImage = res.photo;
         this.EditedQuestionImage_ = Question.EditedQuestionImage



        //new code
      
        var hasData = this.EditQuestionImages_2.find(f => f.QId == QuestionId)
            if(hasData){
                hasData.QImage=this.EditedQuestionImage_;
            }else{
                var obj_ = {
                    QId:QuestionId,
                    QImage:this.EditedQuestionImage_
                }
                this.EditQuestionImages_2.push(obj_);
            }
            this.EditQuestionImages_2.map(x=>{
                if(x.QId==QuestionId){
                    x.QImage = this.EditedQuestionImage_;
                }else{
                    
                }
            })
            
            console.log("QuestionImages", this.EditQuestionImages_2)
      }
    });
  }


  QuestionComments_2=[]
  openAddCommentDialog(QuestionId,commentinfo:DigitalFormQuestionsVM){
    const dialogRef = this.dialog.open(DigitalEditCommentDialogComponent, { 
      disableClose: true,
      data:{
        QuestionId: QuestionId,
        comment_:commentinfo.QuestionComment
      }
    });
  
   dialogRef.afterClosed().subscribe(result => {

    if (result != null) {
      commentinfo.QuestionComment = result;
      this.QuestionComment = commentinfo.QuestionComment


    this.QuestionComment=result;
console.log(this.QuestionComment)
    var hasData = this.QuestionComments_2.find(f => f.QuestionId == QuestionId)
    if(hasData){
        hasData.Comment=this.QuestionComment;
    }else{
        var obj_ = {
          QuestionId:QuestionId,
          Comment:this.QuestionComment
        }
        this.QuestionComments_2.push(obj_);
    }
    this.QuestionComments_2.map(x=>{
        if(x.QuestionId==QuestionId){
            x.Comment = this.QuestionComment;
        }
    })
    }
   });
  
  }
  




  value = ""
  formQAnsList_ = []
  AddValue(Qid, typeId, event: any) {
    let value = "";
    
    if (typeId == 4) {
      value = event.target.value;
     
    }
    if (typeId == 5) {
      //value=this.QuestionNumerical
      value = event.target.value;
      
    }

    if (this.formQAnsList_.find(x => x.Qid == Qid)) {
      console.log("formQAnsList_", this.formQAnsList_)
      this.formQAnsList_.map(z => {
        if (z.Qid == Qid) {
          z.Answers_ = value;
        }
      })
    }
    else {
      let obj = {
        Qid: Qid,
        Qtype: typeId,
        Answers: [],
        Answers_: value
      }
      this.formQAnsList_.push(obj)

    }
    console.log("formQAnsListAddValue", this.formQAnsList_)
  }


  SelectAnswer(Qid, ansID, typeId, event: any) {
    this._inductionService.GetAnswerListForUploadFormDigitalQuestion(Qid).subscribe(res => {
      console.log("GetAnswerListForUploadFormDigitalQuestion", res)
      this.ModelAnswers_ = res
      if (this.formQAnsList_.find(x => x.Qid == Qid)) {
        this.formQAnsList_.map(z => {

          if (z.Qid == Qid) {
            if (typeId != 3) {
              z.Answers.map(a => {
                if (a.AnswerId == ansID) {
                  a.select = true;
                } else {
                  a.select = false;
                }
                //console.log("if array is not empty", a.select)
              })
            } else if (typeId == 3) {
              z.Answers.map(a => {
                if (a.AnswerId == ansID) {
                  a.select = !a.select;
                }
               // console.log("if array is not empty", a.select)
              })
            }
          }
        })
      } else {
        if (typeId != 3) {
          this.ModelAnswers_.map(x => {
            if (x.AnswerId == ansID) {
              x.select = true;
            } else {
              x.select = false;
            }
          })
          let obj = {
            Qid: Qid,
            Qtype: typeId,
            Answers: this.ModelAnswers_,
            Answers_: ""
          }
          this.formQAnsList_.push(obj);
          // console.log("empty array type ID !=3", event.target.value)
        } else if (typeId == 3) { //checkbox answer list
          this.ModelAnswers_.map(x => {
            if (x.AnswerId == ansID) {
              x.select = !x.select;
            }
          })
          let obj = {
            Qid: Qid,
            Qtype: typeId,
            Answers: this.ModelAnswers_,
            Answers_: ""
          }
          //  console.log("empty array type ID ==3", event.target.value)
          this.formQAnsList_.push(obj);
        }
      }
      console.log("formQAnsList_selectAnswer", this.formQAnsList_)
    })
  }


  save() {
    console.log(this.inputValuestate)
    if( this.inputValuestate==null || this.inputValuestate==0){     
    

      this._notify.error('Please select a State.');
      return
    }
   else if(this.inputForm==null){
      
      this._notify.error('Please select a form.');
      return
    }
    else if(this.dateCompleted==null){
      
      this._notify.error('Please enter the Date Completed.');
 
      return
    }
    else{
      this.savingForm = true;
    let model = new AddCompletedDigitalFormReqVM();
    let dateCompleted = new Date(this.dateCompleted);
      //let FollowUpDate = null;
      //if (this.FollowUpDate != "")
      //  FollowUpDate = new Date(this.FollowUpDate);

    model.Id=this.Id
    model.DateCompleted = dateCompleted//this.dateCompleted
    model.Form = this.FormId;
   
    model.FileName = this.NewFileName
    model.IncidentId = this.reportIncidentID!=null?this.reportIncidentID:""
    model.IncidentType = this.incidentType;
    model.Images = this.ImageList
    if(this.FilePreview==null){
      this.FilePreview="";
    }
    var sImageUrl = this.FilePreview.replace(/^data:image\/[a-z]+;base64,/, "");
    sImageUrl = this.FilePreview.replace(/^data:image\/\w+;base64,/, "");
    model.File = this.FilePreview;
    model.RelatedUser = this.relatedUser;
    model.Notes = this.Notes;
    model.FollowUpRequired = this.isActiveFollowUpRequired
    model.FollowUpCompleted = this.isActiveFollowUpCompleted
      model.FollowUpDate = this.FollowUpDate //this.FollowUpDate
    model.FollowUpUser = this.fololowupUser
    model.QuestionAnsList = this.formQAnsList_!
    model.QuestionImages = this.uploadedImages_Q//DigitalFormQuestionImages
    model.EditQuestionImages = this.EditQuestionImages_2
    model.SiteId=this.inputValuestate
    model.QuestionComments=this.QuestionComments_2
    model.FormFiles=this.FileList;
    this._inductionService.EditCompletedDigitalForm(model).subscribe(res => {
      if (res == true) {
       
        this._notify.success('Successfully Saved');
      }
      this.savingForm = false;
    })
    //this.reset();
  }
  }

  @ViewChild('fileUploader') fileUploader: ElementRef;
  @ViewChild('fileUploader_') fileUploader_: ElementRef;

// @ViewChild('fileUploader') fileUploader:ElementRef;
// @ViewChild('fileUploader_') fileUploader_:ElementRef;
  reset() {
    window.location.reload();
    // this.dateCompleted = null;
    // //this.selectedForm = 0;

    // //this.NewFileName=""
    // this.reportIncidentID = "";
    // this.incidentType = 0;
    // this.Image="";
    // this.ImageList = [];
    // //this.FilePreview='',
    // //this.NewFileName = "";
    // this.relatedUser = null;
    // this.Notes = "";
    // this.isActiveFollowUpRequired = false;
    // this.isActiveFollowUpCompleted = false;
    // this.fololowupDate = null;
    // this.fololowupUser = null;
    // this.dateCompleted = null;
    // this.fileUploader.nativeElement.value = null;
    // this.fileUploader_.nativeElement.value = null;
    // this.EditQuestionImages_2=null;
    // this.EditedQuestionImage_=null;
    // this.uploadedImages_Q=null;
    // this.formQAnsList_=[];
    // this.ModelAnswers_=[];
    // this.inputValuestate=0;
    // this.questionsAns=[];    
    // this.ModelAnswers=[]

   this.ngOnInit();
   
  }

//   refresh(): void {
//     window.location.reload();
// }

DeleteForm()
{
  
  if(this.dateCompleted==null){
    this._notify.error('Please enter the Date Completed.');
   
    return
  }
 else if(this.inputForm==null){
  this._notify.error('Please select a form.');
   
    return
  }
  else{
    this.savingForm = true;
        let model= new DeleteFormVM()
        model.Id=this.Id
        this._inductionService.DeleteForm(model).subscribe(res => {
          this._notify.success('Successfully Deleted');
          this.savingForm = false;
        })
      
    

}
}

openConfirmationDialog() {
  const dialogRef = this.dialog.open(ConfirmationMessageDeleteormsComponent, {
    data: {
     
    }
  });
  dialogRef.afterClosed().subscribe(res => {
    if (res == true) {    
      this.DeleteForm(); 
          
    }
  });
}

// onFileChanged(event) {
//   if (event.target.files && event.target.files[0]) {
//     var reader = new FileReader();

//     reader.readAsDataURL(event.target.files[0]); // read file as data url

// //console.log("event.target.files[0]",event.target.files[0])
//     this.NewFileName = event.target.files[0].name
//     reader.onload = (event: FileReaderEvent) => { // called once readAsDataURL is completed
//       var fileUrl = (event.target.result);


//       this.FilePreview = fileUrl;
//     }
//   }
// }

DownloadForm(indx) {
  var _FileData = this.FileList[indx];
  var extention = this.getFileType(_FileData);
  var arrBuffer = this.base64ToArrayBuffer(_FileData);

  if (extention == 'pdf') {
    var blob = new Blob([arrBuffer], { type: 'application/pdf' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = "UploadedFormFile.pdf";
    link.click();
  }
  else if (extention == 'xls' || extention == 'xlsx') {
    var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = "UploadedFormFile." + extention;
    link.click();
  }
  else if (extention == 'doc'|| extention == 'docx') {
    var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download ="UploadedFormDoc."+ extention;
        link.click();
  }

  //else if (extention == 'txt') {
  //  var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
  //  var link = document.createElement('a');
  //  link.href = window.URL.createObjectURL(blob);
  //  link.download = this.NewFileName
  //  link.click();
  //}
  //else if (extention == 'doc') {
  //  var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
  //  var link = document.createElement('a');
  //  link.href = window.URL.createObjectURL(blob);
  //  link.download = this.NewFileName;
  //  link.click();
  //}
}


// DownloadForm()
// {
//   var extention = this.NewFileName.split('.').pop();
//   var arrBuffer = this.base64ToArrayBuffer(this.downloadFileName);

//     if (extention == 'pdf') {
//       var blob = new Blob([arrBuffer], { type: 'application/pdf' });
//       var link = document.createElement('a');
//       link.href = window.URL.createObjectURL(blob);
//       link.download = this.NewFileName;
//       link.click();
//     }
//     else if (extention == 'xls') {
//       var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
//       var link = document.createElement('a');
//       link.href = window.URL.createObjectURL(blob);
//       link.download = this.NewFileName;
//       link.click();
//     }
//     else if (extention == 'docx') {
//       var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
//       var link = document.createElement('a');
//       link.href = window.URL.createObjectURL(blob);
//       link.download = this.NewFileName;
//       link.click();
//     }

//     else if (extention == 'txt') {
//       var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
//       var link = document.createElement('a');
//       link.href = window.URL.createObjectURL(blob);
//       link.download = this.NewFileName
//       link.click();
//     }
//     else if (extention == 'doc') {
//       var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
//       var link = document.createElement('a');
//       link.href = window.URL.createObjectURL(blob);
//       link.download = this.NewFileName;
//       link.click();
//     }
// }

base64ToArrayBuffer(data) {
  var binaryString = window.atob(data);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
  }
  return bytes;
};

base64FileHeaderMapper() {
  //get the first 3 char of base64
  this.fileHeader.set("/9j", "jpg")
  this.fileHeader.set("iVB", "png")
  this.fileHeader.set("Qk0", "bmp")
  this.fileHeader.set("SUk", "tiff")
  this.fileHeader.set("JVB", "pdf")
  this.fileHeader.set("UEs", "doc")
  this.fileHeader.set("RXF", "xls")
  this.fileHeader.set("0M8", "xls")
}

getFileType(fileBase64) {
  let res = ""
  this.fileHeader.forEach((v, k) => {
    if (k == fileBase64.substr(0, 3)) {
      res = v
    }
  })
  //if file is not supported
  if (res == "") {
    res = "unknown"
  }
  //return map value
  return res;
}


onFileChanged(event) {
    if (event.target.files && event.target.files[0]) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (this.UploadedFiles.indexOf(event.target.files[i]["name"]) < 0) {
          this.UploadedFiles.push(event.target.files[i]["name"]);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            this.FileList.push(event.target.result.split(",")[1])
          };
          reader.readAsDataURL(event.target.files[i]);
        }
      }
    }
  }
  
    Deletefilename(filename: any) {
      for (var i = 0; i < this.FileList.length; i++) {
        if (this.FileList[i]["name"] == filename) {
          this.FileList.splice(i, 1);
          this.UploadedFiles.splice(i, 1);
        }
      }
    }
  }
